import gql from "graphql-tag";

export default gql`
  query me {
    me {
      id
      email
      fname
      lname
      role
      hasTaller
      hasTallerA
      students {
        id
        fname
        statusHistory(orderBy: createdAt_DESC) {
          id
          createdAt
          status
        }
        lname
        email
        grade
        status
        role
        parentName
        address
        parentPhone
        municipality
        birthday
        age
        glasses
        specialEducation
        medication
        diet
        diagnostic
        treatment
        arrangements
        transitionTerm
        comments
        parent {
          id
          fname
          lname
        }
      }
      schools {
        id
      }
      schoolsAdmin {
        id
      }
    }
  }
`;
